"use client";

import { ChevronLeft } from "lucide-react";
import Button from "@/components/ui/button";
import useAnchorClick from "@/helpers/anchorScroll";

export default function TopicLink({ href, text }) {
    const handle_click = useAnchorClick();

    return (
        <Button
            href={href || undefined}
            onClick={href ? handle_click(href) : undefined}
            text={text || "مشاهده"}
            end_icon={<ChevronLeft size={16} />}
            color_type="tertiary"
            className="mt-auto pt-2"
        />
    );
}
